{"rating":"4.9","reviewCount":"139","fetchedAt":"2026-10-03T02:49:51.122Z","source":"place-details"}